import Model from './model';

export default class Language extends Model {
  static NAME = 'language';
  static COLLECTION_NAME = "languages";
  static URL = '/api/v2/languages';

  static SUGGESTIONS = [
    'English',
    'French',
    'Spanish',
  ];
}
